var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlineAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7679 5.49262L13.5397 13.2877C13.5118 14.2427 13.1056 15.1697 12.4106 15.8647C11.7155 16.5597 10.7886 16.9659 9.83362 16.9938C8.87866 17.0218 7.97392 16.6692 7.31842 16.0137C6.66293 15.3582 6.31037 14.4535 6.33833 13.4985L6.56649 5.7034C6.58512 5.06676 6.8559 4.44879 7.31925 3.98544C7.7826 3.52209 8.40057 3.25131 9.03721 3.23268C9.67385 3.21404 10.277 3.44908 10.714 3.88607C11.151 4.32307 11.386 4.92623 11.3674 5.56288L11.1349 13.3624C11.1256 13.6807 10.9902 13.9897 10.7585 14.2214C10.5268 14.453 10.2178 14.5884 9.89952 14.5977C9.5812 14.6071 9.27962 14.4895 9.06112 14.271C8.84262 14.0525 8.7251 13.751 8.73442 13.4326L8.94932 6.23537",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineAttachment);
export default __webpack_public_path__ + "static/media/outline-attachment.8569143d.svg";
export { ForwardRef as ReactComponent };